import { resolveComponent as _resolveComponent, withModifiers as _withModifiers, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, mergeProps as _mergeProps, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "w-full" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_date_picker_wrapper = _resolveComponent("v-date-picker-wrapper")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_btn_primary = _resolveComponent("v-btn-primary")!
  const _component_oss_dialog = _resolveComponent("oss-dialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!_ctx.hideActivator)
      ? (_openBlock(), _createBlock(_component_v_text_field, {
          key: 0,
          "model-value": _ctx.formatDate,
          "onUpdate:modelValue": _ctx.onTextFieldValueChanged,
          "append-inner-icon": _ctx.readonly || _ctx.noMenu ? '' : '$oss-calendar',
          "onClick:appendInner": _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.readonly || _ctx.disabled || _ctx.noMenu ? null : (_ctx.dateDialog = true)), ["stop"])),
          onClick: _ctx.openDialogFromTextField,
          onKeypress: _cache[1] || (_cache[1] = ($event: any) => (_ctx.onKeyPress($event))),
          onKeydown: _ctx.handleKeydown,
          onClose: _cache[2] || (_cache[2] = ($event: any) => (_ctx.textFieldValue = '')),
          readonly: _ctx.textFieldReadOnly || _ctx.readonly,
          disabled: _ctx.disabled,
          mandatory: _ctx.mandatory,
          outlined: _ctx.outlined,
          label: _ctx.label,
          placeholder: _ctx.placeholder,
          "hide-details": _ctx.hideDetails,
          rules: [() => _ctx.isValid()],
          "data-cy": _ctx.prefixDataCy ? _ctx.prefixDataCy + 'date' : 'date',
          class: _normalizeClass(_ctx.fullTextFieldClass),
          error: _ctx.error,
          autofocus: _ctx.autofocus,
          hint: _ctx.hint,
          "persistent-hint": _ctx.persistentHint,
          onMouseout: _ctx.onMouseOut,
          onMouseover: _ctx.onMouseOver,
          tabindex: _ctx.tabindex,
          "show-current": _ctx.showCurrent,
          density: _ctx.dense ? 'compact' : 'default',
          style: {"min-width":"150px"},
          required: _ctx.required
        }, null, 8, ["model-value", "onUpdate:modelValue", "append-inner-icon", "onClick", "onKeydown", "readonly", "disabled", "mandatory", "outlined", "label", "placeholder", "hide-details", "rules", "data-cy", "class", "error", "autofocus", "hint", "persistent-hint", "onMouseout", "onMouseover", "tabindex", "show-current", "density", "required"]))
      : _createCommentVNode("", true),
    _createVNode(_component_oss_dialog, {
      ref: "dateDialog",
      modelValue: _ctx.dateDialog,
      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.dateDialog) = $event)),
      persistent: "",
      width: "450px",
      onClose: _cache[6] || (_cache[6] = ($event: any) => (_ctx.close())),
      "without-header": true
    }, {
      actions: _withCtx(() => [
        _createVNode(_component_v_btn_primary, {
          block: "",
          onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.emitDate())),
          "data-cy": _ctx.prefixDataCy + '-date-ok',
          size: "large"
        }, {
          default: _withCtx(() => _cache[7] || (_cache[7] = [
            _createTextVNode("OK")
          ])),
          _: 1
        }, 8, ["data-cy"])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_v_row, { "no-gutters": "" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_col, {
              cols: "12",
              class: "d-flex justify-center"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_date_picker_wrapper, _mergeProps({
                  modelValue: _ctx.localDate,
                  "onUpdate:modelValue": [
                    _cache[3] || (_cache[3] = ($event: any) => ((_ctx.localDate) = $event)),
                    _ctx.onDatePickerValueChanged
                  ]
                }, _ctx.pickerProps, {
                  type: _ctx.type,
                  scrollable: "",
                  "hide-header": "",
                  min: _ctx.minDate,
                  max: _ctx.maxDate,
                  "allowed-dates": _ctx.allowedDates,
                  "first-day-of-week": "1",
                  range: Array.isArray(_ctx.internalValue),
                  "data-cy": _ctx.prefixDataCy + '-calendar'
                }), null, 16, ["modelValue", "onUpdate:modelValue", "type", "min", "max", "allowed-dates", "range", "data-cy"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}